<template>
  <div>
    <validation-provider
      :name="`${question._id}-${question.label}`"
      v-if="hasAnswer(answer) && isRadioType(question) && isRequired(question)"
      rules="required"
      mode="lazy"
      v-slot="{ errors }"
    >
      <h4 class="question_radio__title required" v-html="sanitizedQuestion + ' *'"></h4>
      <p class="question_radio__description">{{ question.attributes.description }}</p>
      <div class="question_radio__options">
        <div 
          v-for="option in question.attributes.options" 
          :key="`${question._id}-${option.value}`" 
          class="question_radio__option"
        >
          <input 
            type="radio" 
            :id="`${question._id}-${option.value}`" 
            :value="option.value" 
            v-model="answer.value"
            :name="`radio-group-${question._id}`"
          />
          <label :for="`${question._id}-${option.value}`">{{ option.label }}</label>
        </div>
      </div>
      <span v-if="errors.length > 0" class="text-danger">
        Campo de resposta obrigatória
      </span>
    </validation-provider>
    <validation-provider
      :name="`${question._id}-${question.label}`"
      v-if="hasAnswer(answer) && isRadioType(question) && !isRequired(question)"
      v-slot="{ errors }"
      mode="lazy"
    >
      <h4 class="question_radio__title" v-html="sanitizedQuestion"></h4>
      <p class="question_radio__description">{{ question.attributes.description }}</p>
      <div class="question_radio__options">
        <div 
          v-for="option in question.attributes.options" 
          :key="`${question._id}-${option.value}`" 
          class="question_radio__option"
        >
          <input 
            type="radio" 
            :id="`${question._id}-${option.value}`" 
            :value="option.value" 
            v-model="answer.value"
            :name="`radio-group-${question._id}`"
          />
          <label :for="`${question._id}-${option.value}`">{{ option.label }}</label>
        </div>
      </div>
      <div v-if="errors.length > 0">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </div>
</template>

<style lang="scss" scoped>
.question_radio__title {
  font-size: 16px;
  font-weight: 400;
  line-height: 18.75px;
  color: #4F4F4F;
  margin: 10px 0;

  // Estilos para listas no conteúdo HTML
  ::v-deep ul {
    list-style-type: disc;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep ol {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 20px;
    margin: 10px 0;
    
    li {
      margin-bottom: 8px;
      line-height: 1.4;
    }
  }

  ::v-deep p {
    margin: 8px 0;
    line-height: 1.4;
  }

  ::v-deep br {
    line-height: 1.4;
  }

  ::v-deep strong {
    font-weight: 600;
  }

  ::v-deep em {
    font-style: italic;
  }

  ::v-deep a {
    color: #4169E1;
    text-decoration: underline;
    
    &:hover {
      color: darken(#4169E1, 15%);
    }
  }
}

.question_radio__description {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  color: #4F4F4F;
  margin-bottom: 10px;
}

.question_radio__options {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}

.question_radio__option {
  display: flex;
  align-items: center;
  gap: 8px;
  border: 0.5px solid #D4D4D4;
  border-radius: 8px;
  padding: 8px 16px;
  
  input[type="radio"] {
    appearance: none;
    background-color: #fff;
    width: 16px;
    height: 16px;
    border: 1px solid #BDBDBD;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    
    &:checked {
      border-color: #4169E1;
      
      &:after {
        content: "";
        width: 8px;
        height: 8px;
        background-color: #4169E1;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
  
  label {
    font-size: 16px;
    color: #4F4F4F;
    cursor: pointer;
  }
}

.required {
  color: #333333;
}
</style>

<script>
import { ValidationProvider } from "vee-validate";
import { sanitizeBasicHtml } from "@/utils/htmlSanitizer";

export default {
  components: { ValidationProvider },
  name: "question-radio",
  props: {
    answer: {
      type: Object,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  methods: {
    hasAnswer: answer => Object.keys(answer).length > 0,
    isRadioType: question => question.type === "radio",
    isRequired: question => question.required
  },
  computed: {
    sanitizedQuestion() {
      return sanitizeBasicHtml(this.question.question);
    },
    optionsExist() {
      return this.question.attributes.options && Array.isArray(this.question.attributes.options) && this.question.attributes.options.length > 0;
    }
  },
  mounted() {
    if (!this.optionsExist && this.isRadioType(this.question)) {
      this.question.attributes.options = [];
    }
  }
};
</script> 